import { Select as antDSelect } from "antd"
import styled from "styled-components"

const Select = styled(antDSelect)`
  color: ${props => props.theme.color.fontColor.pinkColor3};
`

export { Select }
